export const GALLERY_ARTIFACTS_ORIGIN = "https://gallery-artifacts.3b.dev";
